export const images = {
  logoLogin: require('./auth/logo-struck.jpg'),
  logistic: require('./logistic.jpg'),
  backgroud_login: require('./auth/backgroud_login.jpg'),
  logo: require('./logo.png'),
  logoString: require('./logoString.png'),
  logoToc: require('./logo-toc.jpg'),
  logoTocNgang: require('./images.jpeg'),
  logo2: require('./logo2.jpeg'),
}
